import { Paginated } from 'types/paginated';
import { $api } from './interceptor';
import { NetworkTypes, TWallet } from 'views/types/wallets';

type WalletsParams = {
  page?: number;
  limit?: number;
  search?: string;
  networkType?: NetworkTypes;
  showOnlyBlocked?: boolean;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
};

const walletApi = () => {
  const getWallets = async (params: WalletsParams = {}) => {
    const { data } = await $api.get<Paginated<TWallet>>('/api/wallets', {
      params,
    });
    return data;
  };
  return { getWallets };
};

export const walletsService = walletApi();
